import { render, staticRenderFns } from "./ConfirmationCreateTournamentDialog.vue?vue&type=template&id=3ebaf006&scoped=true"
import script from "./ConfirmationCreateTournamentDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationCreateTournamentDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationCreateTournamentDialog.vue?vue&type=style&index=0&id=3ebaf006&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebaf006",
  null
  
)

export default component.exports